import React, { useEffect, useState, useCallback, useContext } from "react";
import { View, Text, Image } from "react-native-web";
import Header from "../survey/Header";
import Footer from "../survey/Footer";
import moment from "moment";
import queryString from "query-string";
import { AuthContext } from "../Auth.js";
import { Spin, Button, Input } from "antd";
import Firebase from "firebase";
import app from "../base";
import Chart from "./Chart/Chart";
import logo from "../logo.png";

const CryptoJS = require("crypto-js");
const dbRef = Firebase.database().ref();

const Live = (props) => {
	const { currentUser } = useContext(AuthContext);
	const [currentPoll, setCurrentPoll] = useState(null);
	const [isPollExists, setPollExists] = useState(true);
	const [isLoading, setLoading] = useState(true);
	const [indicator, setIndicator] = useState(null);
	const [firebaseRef, setFirebaseRef] = useState(null);
	const [votesPerOption, setVotesPerOption] = useState(true);
	const [totalVotes, setTotalVotes] = useState(true);
	const [validated, setValidated] = useState(true);
	const [notValid, setNotValid] = useState(false);
	const [passcode, setPasscode] = useState(-1);
	const [actualPasscode, setActualPasscode] = useState(-1);

	useEffect(() => {
		async function fetchPollData() {
			try {
				var poll = null;
				var table = null;

				const params = queryString.parse(props.location.search);
				if (!params.lid) {
					setPollExists(false);
				} else {
					if (params.p) {
						if (!params.u) {
							setPollExists(false);
						} else {
							table = `privatePolls/${params.u}/${params.lid}`;
						}
					} else {
						if (params.gid) {
							table = `groupPolls/${params.gid}/${params.lid}`;
						} else {
							table = `suggestions/${params.lid}`;
						}
					}
				}

				var suggestion = await dbRef.child(table).once("value");

				if (suggestion.exists()) {
					poll = suggestion.val();
				} else {
					setPollExists(false);
				}

				if (!poll) {
					setPollExists(false);
				} else {
					setTotalVotes(poll.totalVotes);
					setVotesPerOption(poll.votesPerOption);
					setCurrentPoll(poll);

					if (poll.secure) {
						setValidated(false);
						setActualPasscode(
							CryptoJS.enc.Base64.parse(poll.passcode).toString(
								CryptoJS.enc.Utf8
							)
						);
					}

					const ref = Firebase.database().ref(table);
					const liveIndictor = ref.on("child_changed", (snapShot) => {
						if (!snapShot.val()) {
							return;
						}

						if (snapShot.key == "votesPerOption") {
							setVotesPerOption(snapShot.val());
						}

						if (snapShot.key == "totalVotes") {
							setTotalVotes(snapShot.val());
						}
					});

					setFirebaseRef(ref);
					setIndicator(indicator);
				}
				setLoading(false);
			} catch (error) {
				console.log(error);
			}
		}

		fetchPollData();

		// returned function will be called on component unmount
		return () => {
			if (firebaseRef) {
				firebaseRef.off("child_changed", indicator);
			}
		};
	}, [currentUser, props]);

	if (isLoading) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				<Spin style={{ marginTop: 20 }} size="large" />
			</div>
		);
	}

	if (!validated) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
				}}
			>
				<View style={{ alignItems: "center" }}>
					<Image
						source={logo}
						style={{
							height: 70,
							width: 70,
							borderRadius: 10,
							marginBottom: 30,
						}}
					/>

					<View
						style={{
							height: 60,
							alignItems: "center",
						}}
					>
						<input
							style={{
								fontSize: 18,
								textAlign: "center",
								fontFamily: "NunitoSans",
								fontWeight: "500",
								height: 40,
							}}
							maxLength="5"
							onChange={(e) => setPasscode(e.target.value)}
							placeholder="Enter passcode"
						/>
						{notValid && (
							<Text
								style={{
									height: 20,
									color: "red",
									fontFamily: "NunitoSans",
									fontWeight: "500",
								}}
							>
								Incorrect passcode
							</Text>
						)}
					</View>

					<Button
						type="primary"
						style={{
							borderRadius: 25,
							marginTop: 30,
							height: 40,
							width: 100,
							fontSize: 16,
							fontWeight: "600",
							backgroundColor: "#196BFF",
						}}
						onClick={() => {
							setNotValid(passcode !== actualPasscode);
							setValidated(passcode == actualPasscode);
						}}
					>
						Enter
					</Button>
				</View>
			</div>
		);
	}

	return (
		<View>
			<Header text={"Live Poll Results"} />

			{!isPollExists ? (
				<View
					style={{
						alignItems: "center",
						justifyContent: "center",
						height: 300,
					}}
				>
					<Text
						style={{
							fontSize: 20,
							fontWeight: "600",
							marginVertical: 20,
							textAlign: "center",
						}}
					>
						Poll does't not exist :(
					</Text>
				</View>
			) : (
				<Chart
					currentPoll={currentPoll}
					votesPerOption={votesPerOption}
					totalVotes={totalVotes}
				/>
			)}

			{currentPoll && (
				<View style={{ alignItems: "center", marginTop: 20 }}>
					<Text style={{ fontSize: 15, fontWeight: "500", fontFamily: "NunitoSans" }}>
						{"Poll ends "}
						{moment(currentPoll.enddate).fromNow()}
					</Text>
					<Button
						type="primary"
						style={{
							borderRadius: 25,
							marginTop: 20,
							height: 40,
							width: 200,
							fontSize: 16,
							fontWeight: "600",
							backgroundColor: "#196BFF",
						}}
						onClick={() => app.auth().signOut()}
					>
						Sign out
					</Button>
				</View>
			)}

			{/* <Footer totalVotes={totalVotes} /> */}
		</View>
	);
};
export default Live;
